function getIamgePrefix() {
  return "https://dos-covers.zczc.cz/";
}

export const cover_image_prefix = getIamgePrefix();